import React, { memo, useMemo, useCallback } from 'react';
import { FormSelect } from '@core/components/form';
import { useObservable } from '@core/utils/hooks/rxjs';
import { useBloc } from '@core/utils/bloc';
import { CommonService } from '@business/services';
import { OrgChartBlockWidgetForm, OrgChartBlockVariation } from './OrgChartBlock';
import { OrgChartBlockBloc } from './OrgChartBlockBloc';
import { R } from '@core/utils/r';

export interface OrgChartBlockSettingsProps {
  form: OrgChartBlockWidgetForm;
  variation: OrgChartBlockVariation;
  onFormChange(content: string): void;
}

export const OrgChartBlockSettings = memo((props: OrgChartBlockSettingsProps) => {
  const { form, variation, onFormChange } = props;
  const bloc = useBloc(OrgChartBlockBloc, variation);
  const data = useObservable(bloc.items$);
  const items = useMemo(() => CommonService.selectItems(data || [], 'name', 'id'), [data]);

  const onChange = useCallback(
    (value: string) => {
      const chart = R.find(data, i => i.id == value);
      if (chart) {
        onFormChange(chart.content as string);
        form.patchValue({ text: chart.content as string, heading: chart.name });
      }
    },
    [data, form, onFormChange],
  );

  return (
    <div>
      <FormSelect control={form.controls.id} items={items} onChange={onChange} />
    </div>
  );
});
